import { Component, OnInit } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MeasureManagementService } from '../measure-management.service';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-measure-management-detail',
  templateUrl: './measure-management-detail.component.html',
  styleUrls: ['./measure-management-detail.component.scss']
})
export class MeasureManagementDetailComponent implements OnInit {

  measure;
  measureID: string;
  measureStatus: string = '';
  measureName: string;
  isLoading: boolean = false;

  constructor(
    private measureManagementService: MeasureManagementService,
    private router: Router,
    private gobalFunctionService: GobalFunctionService,
    public matDialog: MatDialog,
  ) { }

  ngOnInit(): void {

    this.measureID = new URL(location.href).searchParams.get('measure_id');
    this.gobalFunctionService.setTitle('รายละเอียดแบบทดสอบ');

    this.measureManagementService.getDetailMeasureById(this.measureID).pipe(
      map(res => {
        if (res.success) {
          this.measure = res.result[0];
          // console.log(this.measure);
          this.measureStatus = this.measure.STATUS_PUBLIC;
          this.measureName = this.measure.MEASURE_NAME
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(null);
      })
    ).subscribe();

  }

  status() {
    // console.log(this.measureStatus);

    let body = {
      MEASURE_ID: this.measureID,
      STATUS_PUBLIC: this.measureStatus
    }
    const dialogConfig1 = new MatDialogConfig();
    dialogConfig1.disableClose = true;
    dialogConfig1.id = 'modalConfirm';
    dialogConfig1.width = '500px';
    dialogConfig1.data = {
      title: 'อัปเดตสถานะ',
      description: `<h5>ต้องการเปลี่ยนสถานะของแบบทดสอบ "${this.measureName}"
      เป็น <span class="text-primary">"${this.measureStatus}"</span> ใช่หรือไม่</h5>`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
      customStyle: 'background-color: #58595B;'
    }

    const modalDuplicate = this.matDialog.open(ModalComponent, dialogConfig1);
    modalDuplicate.afterClosed().pipe(
      switchMap(status => {
        this.isLoading = true;
        if (status) {
          return this.measureManagementService.updateStatusMeasure(body).pipe(
            switchMap(res => {
              if (res.success) {
                this.isLoading = false;
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalConfirm';
                dialogConfig.width = '350px';
                dialogConfig.data = {
                  title: 'อัปเดตสถานะ',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">${res.message}`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig);
                return modal.afterClosed().pipe(
                  map(res => {
                    if (!res) {
                      // console.log(res);
                      // window.opener.location.reload();
                      // setTimeout(() => {
                      //   window.close()
                      // }, 100);
                    }
                  })
                )
              } else {
                // console.log(res);
                alert(res.message);
                return of(null);
              }
            })
          )
        } else {
          this.isLoading = false;
          this.measureStatus = this.measureStatus === 'private' ? 'public' : 'private';
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message)
        this.isLoading = false;
        return of(null);
      }),
    ).subscribe()
  }

  edit(mid) {
    window.open('/measure-management/manage-measure?isEdit=true&measure_id=' + mid, '_blank');
  }

  duplicate() {
    let body = {
      MEASURE_ID: this.measureID
    }
    const dialogConfig1 = new MatDialogConfig();
    dialogConfig1.disableClose = true;
    dialogConfig1.id = 'modalConfirm';
    dialogConfig1.width = '500px';
    dialogConfig1.data = {
      title: 'Duplicate แบบทดสอบ',
      description: `<h5>ต้องการ Duplicate แบบทดสอบ <span class="text-primary">"${this.measureName}"</span> ใช่หรือไม่</h5>`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
      customStyle: 'background-color: #58595B;'
    }

    const modalDuplicate = this.matDialog.open(ModalComponent, dialogConfig1);
    modalDuplicate.afterClosed().pipe(
      switchMap(dup => {
        this.isLoading = true;
        if (dup) {
          return this.measureManagementService.dupplicateMeasureById(body).pipe(
            switchMap(res => {
              if (res.success) {
                // console.log(res);
                let mid = res.result.MEASURE_ID;
                this.isLoading = false;
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalConfirm';
                dialogConfig.width = '500px';
                dialogConfig.data = {
                  title: 'Duplicate แบบทดสอบสำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                  <h5>Duplicate แบบทดสอบ <span class="text-primary">"${res.result.MEASURE_NAME}"</span> สำเร็จแล้ว</h5>`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig);
                return modal.afterClosed().pipe(
                  map(res => {
                    if (!res) {
                      // console.log(res);
                      window.open('/measure-management/measure-managament-detail?measure_id=' + mid, '_blank');
                    }
                  })
                )
              } else {
                // console.log(res);
                alert(res.message);
                return of(null);
              }
            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message)
        this.isLoading = false;
        return of(null);
      }),
    ).subscribe()

  }

  delete() {
    let body = {
      MEASURE_ID: this.measureID
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '500px';
    dialogConfig.data = {
      title: 'ลบแบบทดสอบ',
      description: `<h5>ต้องการลบแบบทดสอบ <span class="text-primary">"${this.measureName}"</span> ใช่หรือไม่</h5>`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
      customStyle: 'background-color: #58595B;'
    }

    const modalDelete = this.matDialog.open(ModalComponent, dialogConfig);
    modalDelete.afterClosed().pipe(
      switchMap(isDelete => {
        this.isLoading = true;
        if (isDelete) {
          return this.measureManagementService.delMeasureById(body).pipe(
            switchMap(res => {
              if (res.success) {
                this.isLoading = false;
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalConfirm';
                dialogConfig.width = '500px';
                dialogConfig.data = {
                  title: 'ลบแบบทดสอบสำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                  <h5>ลบแบบทดสอบ <span class="text-primary">"${this.measureName}"</span> สำเร็จแล้ว</h5>`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig);
                return modal.afterClosed().pipe(
                  map(res => {
                    if (!res) {
                      window.opener.location.reload();
                      setTimeout(() => {
                        window.close()
                      }, 10);
                    }
                  })
                )
              } else {
                alert(res.message);
                return of(null);
              }
            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message)
        this.isLoading = false;
        return of(null);
      }),
    ).subscribe()

  }


}
